<template>
  <div id="app">
    <Loader />
    <Navbar />
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import Footer from '@/components/Footer'
export default {
  components: {
    Loader,
    Navbar,
    Footer
  },
  name: 'App'
}
</script>

<style>
  .tooltip-inner {
      background-color: #1D67BD!important;
  }
  .tooltip.bs-tooltip-top .arrow:before {
      border-top-color: #1D67BD !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue